const state = () => ({
  isValid: false,
  lastName: ''
});

const getters = {
  isValid(state) {
    return state.isValid;
  },
  lastName(state) {
    return state.lastName;
  }
};

const mutations = {
  setIsValid(state, payload) {
    state.isValid = payload;
  },
  updateLastName(state, payload) {
    state.lastName = payload;
  },
  resetStore(storeState) {
    Object.assign(storeState, state());
  }
};

const actions = {
  updateLastName({ commit }, payload) {
    commit('updateLastName', payload);
  }
};

export const lastName = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
